import CreateCopyViewButton from '@components/copy-view/CreateCopyViewButton';
import { SavedViewButtonsTrackingTags } from '@ecosystem/newron-client-lib';
import { ExploreViewState } from '@models/SavedViews';

interface ExportCopyViewButtonProps {
  exploreViewState: ExploreViewState;
  copyViewTracking: Object;
}

const ExploreCopyViewButton: React.FC<ExportCopyViewButtonProps> = ({ copyViewTracking, exploreViewState }) => {
  const createViewState = () => {
    return exploreViewState;
  };
  const createTrackingTags = () => {
    return copyViewTracking as SavedViewButtonsTrackingTags;
  };
  return <CreateCopyViewButton createViewFunction={createViewState} copyViewTracking={createTrackingTags} />;
};

export default ExploreCopyViewButton;
